"use strict";

window.infiniteScrollObserver = new IntersectionObserver((entries, observer) => {
    for (const entry of entries) {
        if (entry.isIntersecting) {
            entry.target.click();
        }
    }
});

for (const element of document.querySelectorAll('.more-results a')) {
    window.infiniteScrollObserver.observe(element);
}
